import { helpers } from '@vuelidate/validators';

export default function sameAsOther(attr) {
	return function (value, state) {
		return !helpers.req(value) || value === state[attr];
	};
}
